import { render, staticRenderFns } from "./DashboardCoursesTable.vue?vue&type=template&id=e5e7d10c&"
import script from "./DashboardCoursesTable.vue?vue&type=script&lang=js&"
export * from "./DashboardCoursesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports